import React from 'react';
import Div from '../../Element/Div/Div';
import Title from '../../Typography/Title/Title';
import MarginSpace from '../../MarginSpace/MarginSpace';
import { CreateProps } from '../../../types/utils/CreateProps';

type PageTitleProps = CreateProps<
  {
    /** To make the title narrow */
    narrow?: boolean;
  },
  typeof Title
>;

const PageTitle: React.FunctionComponent<PageTitleProps> = ({
  children,
  narrow,
  ...props
}) => {
  return (
    <MarginSpace narrow={narrow} noPaddingForSmallerThanSm={narrow}>
      <Div padding={{ horizontal: narrow ? 'md' : 'zero' }}>
        <Title tagName="h2" size="sm" {...props}>
          {children}
        </Title>
      </Div>
    </MarginSpace>
  );
};

export default PageTitle;
